import { LegalDocumentDataType } from '@oy/types';
import { createContext, Dispatch, SetStateAction } from 'react';

type SignLegalDocumentModalContextType = {
  allDocument: LegalDocumentDataType[];
  payloadToSignDocuments: string[];
  isBottom: boolean;
  selectedDocument?: string;
  agreementNumber?: string;
  onAddSignedDocument: (documentId: string) => void;
  onChangeAgreementNumber: (value?: string) => void;
  onSubmit: () => void;
  resetPosition: () => void;
  setRef: Dispatch<SetStateAction<HTMLDivElement | null>>;
};

export const defaultContextValue: SignLegalDocumentModalContextType = {
  allDocument: [],
  payloadToSignDocuments: [],
  isBottom: false,
  agreementNumber: undefined,
  onAddSignedDocument: (document: string) => {
    console.log(document);
  },
  onChangeAgreementNumber: (value?: string) => {
    console.log(value);
  },
  setRef: () => {},
  onSubmit: () => {},
  resetPosition: () => {},
};

export const SignLegalDocumentModalContext = createContext(defaultContextValue);
